//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import unionBy from "lodash/unionBy"

const handleSelectObjects = (items) => {
  return items.map(x => {
    return {
      label: x.label,
      id: x.id,
      key: x.id,
      fuzzy: x.fuzzy,
      raw: x
    }
  })
}

export default {
  name: "ObjectSelectSearchable",
  props: {
    value: {
      type: [String, Array, undefined],
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Объект'
    },
    width: {
      type: Number,
      default: 300
    },
    excludeObjects: {
      type: Array,
      default: () => {
        return []
      }
    },
    eventsFilter: {
      type: [Number, null],
      default: 0
    },
    many: {
      type: Boolean,
      default: false
    },
    filterTypes: {
      type: Array,
      default: () => {
        return []
      }
    },
    size: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    extraFilters: {
      type: Object,
      default: () => Object()
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    selectedObjects: {
      type: Boolean,
      default: false
    },
    addedObjects: {
      type: Array,
      required: false,
      default: () => []
    },
    objectsWithMap: {
      type: Boolean,
      default: false
    },
    objectsWithQuotes: {
      type: Boolean,
      default: false
    },
    store: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      optionsList: [],
    }
  },
  computed: {
    resolvedStore() {
      return this.$store || this.store || null
    },
    selected_object: {
      get() {
        if (!this.many && Array.isArray(this.value)) {
          return this.value.length ? this.value[0] : undefined
        } else {
          return this.value;
        }
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    valueIsArray() {
      return Array.isArray(this.selected_object)
    },
    availableOptions() {
      const store = this.resolvedStore
      const cached = store && store.getters ? (store.getters["objects/cachedObjectsGetter"] || []) : []
      return unionBy([
        ...cached.filter(x => {
          if (this.valueIsArray) {
            return this.selected_object && this.selected_object.includes(x.key)
          } else {
            return x.key === this.selected_object
          }
        }),
        ...this.optionsList
      ], 'key')
    }
  },
  mounted() {
    if (!this.selected_object) return
    const store = this.resolvedStore
    if (!store) return
    store.dispatch('objects/publicSearch', {
      ids: this.valueIsArray ? this.selectedObjects ? this.selected_object.map(el => el.id).join(',') : this.selected_object.join(',') : this.selected_object,
      limit: this.valueIsArray ? this.selected_object.length ? this.selected_object.length : 1 : 1,
      is_about_project: null
    })
      .then(items => {
        store.dispatch('objects/addToCache', handleSelectObjects(items))
      })
      .finally(() => {
        this.loading = false
      })
    return;

    if (!this.$store.getters["objects/cachedObjectsGetter"].find(x => {
      if (this.valueIsArray) {
        return this.selected_object.includes(x.key)
      } else {
        return x.key === this.selected_object
      }
    })) {
      this.loading = true
      this.$store.dispatch('objects/publicSearch', {
        ids: this.valueIsArray ? this.selected_object.join(',') : this.selected_object,
        limit: this.valueIsArray ? this.selected_object.length : 1,
        is_about_project: null
      })
        .then(items => {
          this.$store.dispatch('objects/addToCache', handleSelectObjects(items))
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  methods: {
    findObjects: function (search, limit = 15, offset = 0, ids) {
      const store = this.resolvedStore
      if (!store) {
        return Promise.resolve({ items: [], total: 0 })
      }
      let idFilter = ''
      if (ids && Array.isArray(ids)) {
        idFilter = ids.join(',')
      }
      const payload = {
        q: search,
        exclude: this.excludeObjects.filter(x => x).join(','),
        limit: limit,
        offset: offset,
        types: this.filterTypes.join(','),
        ids: idFilter,
        ...({ with_quotes: this.objectsWithQuotes }),
        ...this.extraFilters
      }
      if (Number.isInteger(this.eventsFilter)) payload.is_events = this.eventsFilter

      return store.dispatch(this.objectsWithMap ? 'objects/fetchWithMapObjects' : 'objects/fetchPublicObjects', payload)
        .then(({ items, total }) => {
          const addedObjectsIds = this.addedObjects.map(el => el.id)
          let filterAddedItems = items.filter(el => {
            if (!addedObjectsIds.includes(el.id)) {
              return el
            }
          })

          const processedItems = handleSelectObjects(filterAddedItems.map(x => {
            x.fuzzy = x.search_group !== 'label'
            return x
          }))

          // store.dispatch('objects/addToCache', processedItems)

          return {
            items: processedItems,
            total: total
          }
        })
    },
    handleSelect(val) {
      const store = this.resolvedStore
      if (store) store.dispatch('objects/addToCache', val)
      this.$emit('select-object', val)
    },
    getOptionLabel(option) {
      if (typeof option === "string") {
        const store = this.resolvedStore
        const cached = store && store.getters ? (store.getters["objects/cachedObjectsGetter"] || []) : []
        return cached.find(x => x.key === option)?.label
      } else {
        return option.label
      }
    }
  }
}
